// İngiltere/Çocuk Kitabı temasına uygun, pastel tonlu ve profesyonel şablon
export const LITTLE_HIBBA_TEMPLATE = `
<div style="background-color: #f4f6f8; padding: 40px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;">
    <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
        
        <div style="background-color: #2C3E50; padding: 40px 20px; text-align: center; background-image: url('https://via.placeholder.com/600x200/2C3E50/ffffff?text=LITTLE+HIBBA+STUDIO'); background-size: cover; background-position: center;">
            <h1 style="color: #ffffff; margin: 0; font-size: 28px; letter-spacing: 2px; text-shadow: 0 2px 4px rgba(0,0,0,0.3);">LITTLE HIBBA</h1>
        </div>

        <div style="padding: 40px 30px; color: #4a5568; line-height: 1.8;">
            <h2 style="color: #2d3748; margin-top: 0; font-size: 24px;">Hello Storyteller,</h2>
            <p style="margin-bottom: 20px;">We hope this email finds you well. The studio has been buzzing with creativity lately!</p>
            
            <div style="background-color: #f8fafc; border-left: 4px solid #4299e1; padding: 20px; margin: 30px 0; border-radius: 0 8px 8px 0;">
                <p style="margin: 0; color: #2b6cb0; font-weight: 600; font-size: 16px;">✨ What's New?</p>
                <p style="margin: 5px 0 0; color: #4a5568;">Our latest children's collection is launching this Friday. Get ready for a magical journey!</p>
            </div>

            <p>Whether you represent a publisher or simply love illustrations, we have curated something special just for you.</p>
            
            <div style="text-align: center; margin-top: 40px; margin-bottom: 20px;">
                <a href="https://studio.littlehibba.com" style="background-color: #e53e3e; color: #ffffff; padding: 14px 32px; text-decoration: none; border-radius: 50px; font-weight: bold; font-size: 16px; display: inline-block; transition: background 0.3s;">Explore Collection</a>
            </div>
        </div>

        <div style="background-color: #edf2f7; padding: 30px; text-align: center; font-size: 13px; color: #718096; border-top: 1px solid #e2e8f0;">
            <p style="margin: 0 0 10px; font-weight: 600;">Little Hibba Studio</p>
            <p style="margin: 0 0 15px;">London, United Kingdom 🇬🇧</p>
            <div>
                <a href="#" style="color: #718096; text-decoration: underline; margin: 0 8px;">Unsubscribe</a> • 
                <a href="#" style="color: #718096; text-decoration: underline; margin: 0 8px;">Privacy Policy</a>
            </div>
        </div>
    </div>
    
    <div style="height: 40px;"></div>
</div>
`;